import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component( {
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
} )
export class AppComponent implements OnInit {
    private activeRoute = inject(ActivatedRoute);

    protected renderFrame: boolean = true;

    ngOnInit() {
        this.activeRoute.queryParams.subscribe((params) => {
            this.renderFrame = params['noBorder'] !== 'true';
        });
    }
}
